'use client'

import { Card, Cell, Spacer, Text } from '@vinted/web-ui'
import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import { ErrorState } from '@marketplace-web/error-display/error-display-feature'
import {
  getBusinessAccountsTermsOfUseContent,
  transformBusinessAccountsTermsOfUseResponse,
} from '@marketplace-web/business-accounts/business-accounts-data'

const BusinessAccountsTermsOfUse = () => {
  const {
    fetch: fetchBusinessAccountsTermsofUse,
    transformedData: termsOfUseContent,
    isLoading,
    error,
  } = useFetch(getBusinessAccountsTermsOfUseContent, transformBusinessAccountsTermsOfUseResponse)
  const breakpoints = useBreakpoint()

  useEffect(() => {
    fetchBusinessAccountsTermsofUse()
  }, [fetchBusinessAccountsTermsofUse])

  const renderBannerContent = termsUpdates => {
    return (
      <div className="u-ui-padding-x2-large@desktops">
        <Text as="h1" type={Text.Type.Heading}>
          {termsUpdates.title}
        </Text>
        <div className="u-desktops-only">
          <Spacer size={Spacer.Size.XLarge} />
        </div>
        <div className="u-mobiles-only">
          <Spacer size={Spacer.Size.Medium} />
        </div>
        <div>
          <Text as="span" html>
            {termsUpdates.body}
          </Text>
        </div>
      </div>
    )
  }

  const renderBannerBasedOnBreakpoint = () => {
    if (!termsOfUseContent?.terms_updates) return null

    const { terms_updates } = termsOfUseContent

    if (breakpoints.phones) {
      return (
        <div>
          <Spacer size={Spacer.Size.XLarge} />
          <Card testId="pro-terms-and-conditions-banner">{renderBannerContent(terms_updates)}</Card>
          <Spacer size={Spacer.Size.X4Large} />
        </div>
      )
    }

    return (
      <div>
        <Spacer size={Spacer.Size.X2Large} />
        <Card styling={Card.Styling.Elevated} testId="pro-terms-and-conditions-banner">
          {renderBannerContent(terms_updates)}
        </Card>
        <Spacer size={Spacer.Size.X4Large} />
      </div>
    )
  }

  if (error) return <ErrorState />
  if (isLoading || !termsOfUseContent)
    return <ContentLoader styling={ContentLoader.Styling.Wide} testId="terms-of-use-loader" />

  return (
    <Cell styling={Cell.Styling.Wide}>
      {renderBannerBasedOnBreakpoint()}
      <Text as="h1" type={Text.Type.Heading}>
        {termsOfUseContent.title}
      </Text>
      <Spacer size={Spacer.Size.XLarge} />
      <div className="user-created-content">
        <Text as="span" html>
          {termsOfUseContent.body}
        </Text>
      </div>
    </Cell>
  )
}

export default BusinessAccountsTermsOfUse
